import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-company',
  templateUrl: './setting-company.component.html',
  styleUrls: ['./setting-company.component.scss']
})
export class SettingCompanyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
